import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] bg-navy-900 overflow-hidden flex items-center py-20 lg:py-0" data-id="element-59">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-800 to-navy-900 opacity-90" data-id="element-60" />

      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gold-500/5 blur-[120px] rounded-full" data-id="element-61" />
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-navy-700/20 blur-[100px] rounded-full" data-id="element-62" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-63">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-64">
          {/* Text Content */}
          <div className="text-center lg:text-left" data-id="element-65">
            <FadeIn delay={0.1} data-id="element-66">
              <span className="inline-block px-4 py-2 rounded-full bg-navy-800 border border-navy-700 text-gold-500 font-medium text-sm mb-6 tracking-wide uppercase" data-id="element-67">
                Triada Noche Clara™
              </span>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-68">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-cream-50 leading-tight mb-6" data-id="element-69">
                6 Semanas para <br data-id="element-70" />
                <span className="text-gold-500 italic" data-id="element-71">Dormir Otra Vez</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-72">
              <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-73">
                El diario + plan anti-insomnio diseñado específicamente para
                mayores de 65 años. En español, paso a paso, sin complicaciones.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-74">
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-75">
                <button onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })} className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-bold text-lg px-8 py-4 rounded-lg transition-all transform hover:scale-105 shadow-lg shadow-gold-500/20 flex items-center justify-center gap-2" data-id="element-76">
                  Quiero Dormir Mejor
                  <ArrowRight className="w-5 h-5" data-id="element-77" />
                </button>
                <p className="text-gray-400 text-sm mt-4 sm:mt-0 flex items-center justify-center" data-id="element-78">
                  *Acceso inmediato digital
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Image */}
          <FadeIn delay={0.5} direction="left" className="relative" data-id="element-79">
            <div className="relative mx-auto max-w-md lg:max-w-full" data-id="element-80">
              <div className="absolute inset-0 bg-gold-500/20 blur-3xl rounded-full transform scale-90" data-id="element-81" />
              <img src="https://cdn.magicpatterns.com/uploads/ioCAKsfEE1YVYbYUU2QX8B/heylloyd-image-1770770347937.png" alt="6 Semanas para Dormir Otra Vez - Libro Digital en Tablet" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl border border-navy-700/50 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-82" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}